import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (next !== confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed successfully");
      setCurrent(""); setNext(""); setConfirm(""); setOpen(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="change-password-btn"
          title="Change password"
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold text-zinc-400 hover:text-[#D50A0A] transition-colors"
        >
          <KeyRound className="h-4 w-4" />
          <span className="hidden sm:inline">Password</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#0A0A0A] border-[#1F1F22] text-white">
        <DialogHeader><DialogTitle className="font-display">Change Password</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <label className="text-xs text-zinc-400 font-semibold">Current password</label>
            <input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
              className="mt-1 w-full rounded-lg bg-[#121212] border border-[#1F1F22] px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-[#D50A0A]" placeholder="••••••••" />
          </div>
          <div>
            <label className="text-xs text-zinc-400 font-semibold">New password</label>
            <input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)}
              className="mt-1 w-full rounded-lg bg-[#121212] border border-[#1F1F22] px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-[#D50A0A]" placeholder="At least 4 characters" />
          </div>
          <div>
            <label className="text-xs text-zinc-400 font-semibold">Confirm new password</label>
            <input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-1 w-full rounded-lg bg-[#121212] border border-[#1F1F22] px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-[#D50A0A]" placeholder="Re-enter new password" />
          </div>
        </div>
        <DialogFooter>
          <button data-testid="cp-submit" onClick={submit} disabled={busy || !current || !next}
            className="w-full py-3 rounded-full bg-[#D50A0A] text-white font-bold active:scale-95 transition-transform disabled:opacity-50 flex items-center justify-center gap-2">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update Password
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
